module.exports = __webpack_public_path__ + "img/fourtune-brands.06d76e83.png";